import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';

import { DataTableModule } from 'angular-4-data-table-bootstrap-4';

import { SharedModule } from '../../shared.module';
import { UscStoreMobileService } from '../../services/usc-store-mobile/usc-store-mobile-service';
import { UscAssociateScorecardComponent } from './usc-associate-scorecard/usc-associate-scorecard.component';
import { UscTableViewComponent } from './usc-table-view/usc-table-view.component';
import { UscStoreMobileComponent } from './usc-store-mobile.component';
import { UscScorecardDetailedResultsComponent } from './usc-scorecard-detailed-results/usc-scorecard-detailed-results.component';
import { UscP2wDetailedResultsComponent } from './usc-p2w-detailed-results/usc-p2w-detailed-results.component';
import { UscMobileActionPlansComponent } from './usc-mobile-action-plans/usc-mobile-action-plans.component';
import { UscNextMonthActionPlansComponent } from './usc-next-month-action-plans/usc-next-month-action-plans.component';
import { UscThisMonthActionPlansComponent } from './usc-this-month-action-plans/usc-this-month-action-plans.component';
import { UscPrevMonthActionPlansComponent } from './usc-prev-month-action-plans/usc-prev-month-action-plans.component';
import { UscMobileActionPlanTableComponent } from './usc-mobile-action-plan-table/usc-mobile-action-plan-table.component';

const UscStoreMobileRouting: ModuleWithProviders = RouterModule.forChild([
    { path: 'usc-store-mobile/associate-scorecard',         component: UscAssociateScorecardComponent, }, 
    { path: 'usc-store-mobile/scorecard-detailed-results',  component: UscScorecardDetailedResultsComponent, }, 
    { path: 'usc-store-mobile/p2w-detailed-results',        component: UscP2wDetailedResultsComponent, }, 
    { path: 'usc-store-mobile/this-month-action-plans',     component: UscThisMonthActionPlansComponent, }, 
    { path: 'usc-store-mobile/next-month-action-plans',     component: UscNextMonthActionPlansComponent, }, 
    { path: 'usc-store-mobile/prev-months-action-plans',    component: UscPrevMonthActionPlansComponent, },
    { path: 'usc-store-mobile/mobile-action-plan-table',    component: UscMobileActionPlanTableComponent, },
]);

@NgModule({
    exports: [
    ],
    imports: [
        NgbDropdownModule.forRoot(),
        UscStoreMobileRouting,
        SharedModule,
        DataTableModule,
        NgxMaskModule.forRoot(),
    ],
    declarations: [
        UscStoreMobileComponent,
        UscTableViewComponent,
        UscAssociateScorecardComponent,
        UscScorecardDetailedResultsComponent,
        UscP2wDetailedResultsComponent,
        UscMobileActionPlansComponent,
        UscThisMonthActionPlansComponent,
        UscNextMonthActionPlansComponent,
        UscPrevMonthActionPlansComponent,
        UscMobileActionPlanTableComponent,
    ],
    providers: [
        UscStoreMobileService,
        NgbModal,
        NgbActiveModal,
    ],
    // add components here for dynamic loading
    entryComponents: [
    ]
})

export class UscStoreMobileModule { }



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-mobile/usc-store-mobile.module.ts